export const PROJECTS = [
  {
    id: "last-two",
    cat: "Conservation",
    title: "The Last Two",
    img: "rhino-hero.jpg",
    year: "2022 — ongoing",
    count: "58 frames",
    big: true,
    dek: "A multi-year document of the final two northern white rhinos and the people keeping them alive.",
    lead: "The Last Two began as a single assignment and refused to end. Three years on, it has become the work I measure everything else against.",
    quote: "Some projects you choose. This one chose me, and then would not let go.",
  },
  {
    id: "nosso-dakar",
    cat: "Motorsport",
    title: "O Nosso Dakar",
    img: "cjmeister-com-_DSC4977-Edit-Edit.jpg",
    year: "2023",
    count: "134 frames",
    dek: "An independent photo-essay following privateer riders through the world's hardest rally.",
    lead: "No team, no press pass, no plan beyond keeping up. Just a bike, a camera, and two weeks of dust.",
    quote: "The rally does not care who is watching. That is exactly why it is worth photographing.",
  },
  {
    id: "birds",
    cat: "Studio",
    title: "Birds of Prey",
    img: "cjmeister-com-_CJ00463.jpg",
    year: "2021",
    count: "40 frames",
    dek: "A studio series portraying raptors as individuals rather than specimens.",
    lead: "I wanted to photograph these birds the way you would photograph a person sitting for a portrait — with attention, and a little nerves.",
    quote: "An eagle does not pose. It permits. There is a difference, and the camera knows it.",
  },
  {
    id: "atlantic",
    cat: "Landscape",
    title: "Atlantic Notes",
    img: "cjmeister-com-_CJ08407.jpg",
    year: "2020 — ongoing",
    count: "72 frames",
    dek: "An open-ended series made along the coastlines of a new home.",
    lead: "When you move somewhere new, the only way to understand it is to walk it with a camera until it stops being strange.",
    quote: "A place becomes home the moment you have photographed it badly enough times to start getting it right.",
  },
  {
    id: "figure",
    cat: "Fine Art",
    title: "Figure Studies",
    img: "cjmeister-com-_DSC6660-Edit.jpg",
    year: "2020",
    count: "24 frames",
    dek: "A quiet, formal series exploring light, line and the human form.",
    lead: "The figure is the oldest subject there is. The challenge is finding something in it that has not already been said a thousand times.",
    quote: "Restraint is the whole project. Everything I left out is the point.",
  },
  {
    id: "people-road",
    cat: "Documentary",
    title: "People of the Road",
    img: "cjmeister-com-06076.jpg",
    year: "2019 — ongoing",
    count: "96 frames",
    dek: "Portraits of the strangers who turn a journey into a story.",
    lead: "Every trip leaves me with a folder of faces. This project is what happens when I stop treating them as souvenirs and start treating them as the work.",
    quote: "You can travel a thousand miles for a landscape and come home changed by a five-minute conversation.",
  },
];

/** @param {string} id */
export function getProjectById(id) {
  return PROJECTS.find((project) => project.id === id);
}

/** @param {string} id */
export function getRelatedProjects(id) {
  return PROJECTS.filter((project) => project.id !== id).slice(0, 3);
}
